import fileUtil from '@/utils/fileUtil';
import React, {useMemo} from "react";
import {Image, Link} from "@chakra-ui/react";

export const FilePreview = ({ fileUrl, alt = 'Prévisualisation', ...props }) => {

    const fileType = useMemo(() => {
        return fileUtil.getFileTypeFromUrl(fileUrl);
    }, [fileUrl]);

    switch (fileType) {
        case 'image':
            return <Image fit="contain" src={fileUrl} alt={alt} {...props}/>
        case 'pdf':
            return <iframe
                src={fileUrl}
                style={{
                    position: 'absolute',
                    top: '0',
                    bottom: '0',
                    left: '0',
                    right: '0',
                    width: '100%',
                    height: '100%',
                    containerType: 'size',
                    overflow: 'hidden',
                }}
            />;
        case 'doc':
            const viewerUrl = `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(fileUrl)}`;
            return <iframe
                src={viewerUrl}
                style={{
                    position: 'absolute',
                    top: '0',
                    bottom: '0',
                    left: '0',
                    right: '0',
                    width: '100%',
                    height: '100%',
                    containerType: 'size',
                    overflow: 'hidden',
                }}
            />;
        default:
            return <Link href={fileUrl} target="_blank" {...props}>{fileUrl}</Link>;
    }
};

export default FilePreview;
